<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="user in userList" :value="user.id" :label="user.fullName" :key="user.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    },
    approverOnly: {
      default: false
    }
  },
  data () {
    return {
      userList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchuserList () {
      this.isLoading = true
      var call = ''
      if (this.approverOnly) {
        call = '/getPEAUserApproversList'
        this.$axios.get(call).then(response => {
          const unsortedList = response.data
          const sortedList = unsortedList.sort((a, b) => (a.fullName.toLowerCase() > b.fullName.toLowerCase()) ? 1 : -1)
          this.userList = sortedList
          this.isLoading = false
        }).catch(reject => {
          this.isLoading = false
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting User List', reject.body, 'error', 30000, '')
        })
      } else {
        call = '/getPEAUserList'
        this.$axios.get(call).then(response => {
          const unsortedList = response.data
          const sortedList = unsortedList.sort((a, b) => (a.fullName.toLowerCase() > b.fullName.toLowerCase()) ? 1 : -1)
          this.userList = sortedList
          this.isLoading = false
        }).catch(reject => {
          this.isLoading = false
          if (this.$route.name === 'Custom Grouping Reports') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Status List', reject.body, 'error', 30000, '')
          } else if (this.$route.name === 'advancedSearch') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Status List', reject.body, 'error', 30000, '')
          }
        })
      }
    }
  },
  created () {
    this.fetchuserList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
